// import Carousel from 'react-bootstrap/Carousel';
// import Card from 'react-bootstrap/Card';
// import Button from 'react-bootstrap/Button';
// import Muskaan from '../assets/Initiatives/Muskaan.png';

// function SliderComp() {
//   return (
//     <Carousel>
//       <Carousel.Item>
//         <Card className="text-center mx-auto" style={{ width: '80%', boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)' }}>
//           <Card.Img
//             variant="top"
//             src={Muskaan}
//             alt="First slide"
//             style={{ maxHeight: '300px', objectFit: 'cover' }}
//           />
//           <Card.Body>
//             <Card.Title>First Slide Label</Card.Title>
//             <Card.Text>
//               Nulla vitae elit libero, a pharetra augue mollis interdum.
//             </Card.Text>
//             <Button variant="primary">Learn More</Button>
//           </Card.Body>
//         </Card>
//       </Carousel.Item>
//       <Carousel.Item>
//         <Card className="text-center mx-auto" style={{ width: '80%', boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)' }}>
//           <Card.Img
//             variant="top"
//             src={Muskaan}
//             alt="Second slide"
//             style={{ maxHeight: '300px', objectFit: 'cover' }}
//           />
//           <Card.Body>
//             <Card.Title>Second Slide Label</Card.Title>
//             <Card.Text>
//               Lorem ipsum dolor sit amet, consectetur adipiscing elit.
//             </Card.Text>
//             <Button variant="primary">Learn More</Button>
//           </Card.Body>
//         </Card>
//       </Carousel.Item>
//       <Carousel.Item>
//         <Card className="text-center mx-auto" style={{ width: '80%', boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)' }}>
//           <Card.Img
//             variant="top"
//             src={Muskaan}
//             alt="Third slide"
//             style={{ maxHeight: '300px', objectFit: 'cover' }}
//           />
//           <Card.Body>
//             <Card.Title>Third Slide Label</Card.Title>
//             <Card.Text>
//               Praesent commodo cursus magna, vel scelerisque nisl consectetur.
//             </Card.Text>
//             <Button variant="primary">Learn More</Button>
//           </Card.Body>
//         </Card>
//       </Carousel.Item>
//     </Carousel>
//   );
// }

// export default SliderComp;

// import Carousel from 'react-bootstrap/Carousel';
// import Card from 'react-bootstrap/Card';
// import Button from 'react-bootstrap/Button';
// import Muskaan from '../assets/Initiatives/Muskaan.png';
// import '../css/SliderComp.css'; // Custom CSS file for styles

// function SliderComp() {
//     return (
//       <div className="slider-comp-container">
//         <Carousel className="carousel-custom" indicators={false} interval={3000}>
//           <Carousel.Item>
//             <div className="carousel-card-container">
//               <Card className="custom-card blur-card">
//                 <Card.Img
//                   variant="top"
//                   src={Muskaan}
//                   alt="Left Slide"
//                   className="custom-card-img"
//                 />
//               </Card>
//               <Card className="custom-card active-card">
//                 <Card.Img
//                   variant="top"
//                   src={Muskaan}
//                   alt="Active Slide"
//                   className="custom-card-img"
//                 />
//                 <Card.Body>
//                   <Card.Title>First Slide Label</Card.Title>
//                   <Card.Text>
//                     Nulla vitae elit libero, a pharetra augue mollis interdum.
//                   </Card.Text>
//                   <Button variant="primary">Learn More</Button>
//                 </Card.Body>
//               </Card>
//               <Card className="custom-card blur-card">
//                 <Card.Img
//                   variant="top"
//                   src={Muskaan}
//                   alt="Right Slide"
//                   className="custom-card-img"
//                 />
//               </Card>
//             </div>
//           </Carousel.Item>
//           <Carousel.Item>
//             <div className="carousel-card-container">
//               <Card className="custom-card blur-card">
//                 <Card.Img
//                   variant="top"
//                   src={Muskaan}
//                   alt="Left Slide"
//                   className="custom-card-img"
//                 />
//               </Card>
//               <Card className="custom-card active-card">
//                 <Card.Img
//                   variant="top"
//                   src={Muskaan}
//                   alt="Active Slide"
//                   className="custom-card-img"
//                 />
//                 <Card.Body>
//                   <Card.Title>Second Slide Label</Card.Title>
//                   <Card.Text>
//                     Lorem ipsum dolor sit amet, consectetur adipiscing elit.
//                   </Card.Text>
//                   <Button variant="primary">Learn More</Button>
//                 </Card.Body>
//               </Card>
//               <Card className="custom-card blur-card">
//                 <Card.Img
//                   variant="top"
//                   src={Muskaan}
//                   alt="Right Slide"
//                   className="custom-card-img"
//                 />
//               </Card>
//             </div>
//           </Carousel.Item>
//           <Carousel.Item>
//             <div className="carousel-card-container">
//               <Card className="custom-card blur-card">
//                 <Card.Img
//                   variant="top"
//                   src={Muskaan}
//                   alt="Left Slide"
//                   className="custom-card-img"
//                 />
//               </Card>
//               <Card className="custom-card active-card">
//                 <Card.Img
//                   variant="top"
//                   src={Muskaan}
//                   alt="Active Slide"
//                   className="custom-card-img"
//                 />
//                 <Card.Body>
//                   <Card.Title>Third Slide Label</Card.Title>
//                   <Card.Text>
//                     Praesent commodo cursus magna, vel scelerisque nisl consectetur.
//                   </Card.Text>
//                   <Button variant="primary">Learn More</Button>
//                 </Card.Body>
//               </Card>
//               <Card className="custom-card blur-card">
//                 <Card.Img
//                   variant="top"
//                   src={Muskaan}
//                   alt="Right Slide"
//                   className="custom-card-img"
//                 />
//               </Card>
//             </div>
//           </Carousel.Item>
//         </Carousel>
//       </div>
//     );
//   }
  
//   export default SliderComp;


import { useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import gyaan from '../assets/Initiatives/Gyaan.jpg';
import nirmaan from '../assets/Initiatives/Nirmaan.jpg';
import gogreen from '../assets/Initiatives/Go-Green.png';
import Muskaan from '../assets/Initiatives/Muskaan.png';

import '../css/SliderComp.css';// Custom CSS for 3D effect



import rightLogo1 from'../assets/PRAPTI.png';
import rightLogo2 from'../assets/DIYA.png';
import rightLogo3 from'../assets/greenathan.png';
import rightLogo4 from'../assets/healthdom.png';

import leftLogo1 from'../assets/logo.png';
import leftLogo2 from'../assets/logo.png';
import leftLogo3 from'../assets/logo.png';
import leftLogo4 from'../assets/logo.png';

import healthdom1 from '../assets/Healthdom/1.jpg';
import healthdom2 from '../assets/Healthdom/2.jpg';
import healthdom3 from '../assets/Healthdom/3.jpg';
import healthdom4 from '../assets/Healthdom/4.jpg';
import healthdom5 from '../assets/Healthdom/5.jpg';
import healthdom6 from '../assets/Healthdom/6.JPG';
import healthdom7 from '../assets/Healthdom/7.JPG';
import healthdom8 from '../assets/Healthdom/8.JPG';
import healthdom9 from '../assets/Healthdom/9.JPG';
import healthdom10 from '../assets/Healthdom/10.JPG';
import healthdom11 from '../assets/Healthdom/11.JPG';
import healthdom12 from '../assets/Healthdom/12.JPG';
import healthdom13 from '../assets/Healthdom/13.JPG';
import healthdom14 from '../assets/Healthdom/14.JPG';
import healthdom15 from '../assets/Healthdom/15.JPG';
import healthdom16 from '../assets/Healthdom/16.JPG';
import healthdom17 from '../assets/Healthdom/17.JPG';
import healthdom18 from '../assets/Healthdom/18.JPG';
import healthdom19 from '../assets/Healthdom/19.jpg';
import healthdom20 from '../assets/Healthdom/20.jpg';
import healthdom21 from '../assets/Healthdom/21.jpg';
import healthdom22 from '../assets/Healthdom/22.jpg';
import healthdom23 from '../assets/Healthdom/23.jpg';
import healthdom24 from '../assets/Healthdom/24.jpg';
import healthdom25 from '../assets/Healthdom/25.jpg';
import healthdom26 from '../assets/Healthdom/26.jpg';
import healthdom27 from '../assets/Healthdom/27.jpg';
import healthdom28 from '../assets/Healthdom/28.jpg';
import healthdom29 from '../assets/Healthdom/29.jpg';
import healthdom30 from '../assets/Healthdom/30.jpg';
import healthdom31 from '../assets/Healthdom/31.jpg';
import healthdom32 from '../assets/Healthdom/32.jpg';
import healthdom33 from '../assets/Healthdom/33.jpg';
import healthdom34 from '../assets/Healthdom/34.jpg';
import healthdom35 from '../assets/Healthdom/35.jpg';
import healthdom36 from '../assets/Healthdom/36.jpg';
import healthdom37 from '../assets/Healthdom/37.jpg';


import greenathan1 from '../assets/Greenathan/1.jpg';
import greenathan2 from '../assets/Greenathan/2.jpg';
import greenathan3 from '../assets/Greenathan/3.jpg';
import greenathan4 from '../assets/Greenathan/4.JPG';
import greenathan5 from '../assets/Greenathan/5.JPG';
import greenathan6 from '../assets/Greenathan/6.JPG';
import greenathan7 from '../assets/Greenathan/7.JPG';
import greenathan8 from '../assets/Greenathan/8.JPG';
import greenathan9 from '../assets/Greenathan/9.jpg';
import greenathan10 from '../assets/Greenathan/10.jpg';
import greenathan11 from '../assets/Greenathan/11.jpg';
import greenathan12 from '../assets/Greenathan/12.jpg';


import prapti1 from '../assets/Prapti/1.jpg';
import prapti2 from '../assets/Prapti/2.jpg';
import prapti3 from '../assets/Prapti/3.jpg';
import prapti4 from '../assets/Prapti/4.jpg';
import prapti5 from '../assets/Prapti/5.jpg';
import prapti6 from '../assets/Prapti/6.jpg';
import prapti7 from '../assets/Prapti/7.jpg';
import prapti8 from '../assets/Prapti/8.jpg';
import prapti9 from '../assets/Prapti/9.jpg';
import prapti10 from '../assets/Prapti/10.jpg';
import prapti11 from '../assets/Prapti/11.jpg';
import prapti12 from '../assets/Prapti/12.jpg';
import prapti13 from '../assets/Prapti/13.jpg';
import prapti14 from '../assets/Prapti/14.jpg';
import prapti15 from '../assets/Prapti/15.jpg';
import prapti16 from '../assets/Prapti/16.jpg';
import prapti17 from '../assets/Prapti/17.jpg';
import prapti18 from '../assets/Prapti/18.jpg';
import prapti19 from '../assets/Prapti/19.jpg';
import prapti20 from '../assets/Prapti/20.jpg';
import prapti21 from '../assets/Prapti/21.JPG';
import prapti22 from '../assets/Prapti/22.JPG';
import prapti23 from '../assets/Prapti/23.JPG';
import prapti24 from '../assets/Prapti/24.JPG';
import prapti25 from '../assets/Prapti/25.JPG';
import prapti26 from '../assets/Prapti/26.JPG';
import prapti27 from '../assets/Prapti/27.jpg';
import prapti28 from '../assets/Prapti/28.jpg';
import prapti29 from '../assets/Prapti/29.jpg';
import prapti30 from '../assets/Prapti/30.jpg';
import prapti31 from '../assets/Prapti/31.jpg';
import prapti32 from '../assets/Prapti/32.jpg';
import prapti33 from '../assets/Prapti/33.jpg';
import prapti34 from '../assets/Prapti/34.jpg';
import prapti35 from '../assets/Prapti/35.jpg';
import prapti36 from '../assets/Prapti/36.jpg';
import prapti37 from '../assets/Prapti/37.jpg';
import prapti38 from '../assets/Prapti/38.jpg';



import janata1 from '../assets/Prapti/Janata Henshel - Community Kitchen/1.jpg';
import janata2 from '../assets/Prapti/Janata Henshel - Community Kitchen/2.jpg';
import janata3 from '../assets/Prapti/Janata Henshel - Community Kitchen/3.jpg';
import janata4 from '../assets/Prapti/Janata Henshel - Community Kitchen/4.jpg';
import janata5 from '../assets/Prapti/Janata Henshel - Community Kitchen/5.jpg';
import janata6 from '../assets/Prapti/Janata Henshel - Community Kitchen/6.jpg';
import janata7 from '../assets/Prapti/Janata Henshel - Community Kitchen/7.jpg';
import janata8 from '../assets/Prapti/Janata Henshel - Community Kitchen/8.jpg';


import natural1 from '../assets/Prapti/Natural Calamity Relief Works/1.jpg';
import natural2 from '../assets/Prapti/Natural Calamity Relief Works/2.jpg';
import natural3 from '../assets/Prapti/Natural Calamity Relief Works/3.jpg';
import natural4 from '../assets/Prapti/Natural Calamity Relief Works/4.jpg';
import natural5 from '../assets/Prapti/Natural Calamity Relief Works/5.jpg';
import natural6 from '../assets/Prapti/Natural Calamity Relief Works/6.jpg';
import natural7 from '../assets/Prapti/Natural Calamity Relief Works/7.jpg';
import natural8 from '../assets/Prapti/Natural Calamity Relief Works/8.jpg';
import natural9 from '../assets/Prapti/Natural Calamity Relief Works/9.jpg';
import natural10 from '../assets/Prapti/Natural Calamity Relief Works/10.jpg';
import natural11 from '../assets/Prapti/Natural Calamity Relief Works/11.jpg';
import natural12 from '../assets/Prapti/Natural Calamity Relief Works/12.jpg';
import natural13 from '../assets/Prapti/Natural Calamity Relief Works/13.jpg';
import natural14 from '../assets/Prapti/Natural Calamity Relief Works/14.jpg';
import natural15 from '../assets/Prapti/Natural Calamity Relief Works/15.jpg';
import natural16 from '../assets/Prapti/Natural Calamity Relief Works/16.jpg';
import natural17 from '../assets/Prapti/Natural Calamity Relief Works/17.jpeg';
import natural18 from '../assets/Prapti/Natural Calamity Relief Works/18.jpeg';
import natural19 from '../assets/Prapti/Natural Calamity Relief Works/19.jpeg';



export const cards = [
  {
    id: 1,
    title: "Healthdom",
    text: `The foundation of success in life is good health, that is the substratum fortune, which is also the basis of happiness. Accumulating a good fortune is impossible with sickness. Healthdome is a step of awareness for our society on behalf of NHRF Which will stand by everyone to become free from diseases and to help to recover from diseases. Moreover, it will help them to lead a healthy life ahead.`,
    text1:`The foundation of success in life is good health, that is the substratum fortune, which is also the basis of happiness.....`,
    image: Muskaan,
    image1: healthdom16,
    leftLogo: leftLogo1,
    rightLogo: rightLogo4,
    blogs: [
      { id: 1, image: healthdom1 },
      { id: 2, image: healthdom2 },
      { id: 3, image: healthdom3 },
      { id: 4, image: healthdom4 },
      { id: 5, image: healthdom5 },
      { id: 6, image: healthdom6 },
      { id: 7, image: healthdom7 },
      { id: 8, image: healthdom8 },
      { id: 9, image: healthdom9 },
      { id: 10, image: healthdom10 },
      { id: 11, image: healthdom11 },
      { id: 12, image: healthdom12 },
      { id: 13, image: healthdom13 },
      { id: 14, image: healthdom14 },
      { id: 15, image: healthdom15 },
      { id: 16, image: healthdom16 },
      { id: 17, image: healthdom17 },
      { id: 18, image: healthdom18 },
      { id: 19, image: healthdom19 },
      { id: 20, image: healthdom20 },
      { id: 21, image: healthdom21 },
      { id: 22, image: healthdom22 },
      { id: 23, image: healthdom23 },
      { id: 24, image: healthdom24 },
      { id: 25, image: healthdom25 },
      { id: 26, image: healthdom26 },
      { id: 27, image: healthdom27 },
      { id: 28, image: healthdom28 },
      { id: 29, image: healthdom29 },
      { id: 30, image: healthdom30 },
      { id: 31, image: healthdom31 },
      { id: 32, image: healthdom32 },
      { id: 33, image: healthdom33 },
      { id: 34, image: healthdom34 },
      { id: 35, image: healthdom35 },
      { id: 36, image: healthdom36 },
      { id: 37, image: healthdom37 }
    ],
    projects:[]   
  },
  {
    id: 2,
    title: "Greenathan",
    text: `Our modern technology owes ecology an apology. Therefore, GREENATHON is a race where NHRF and its members have taken challenge Co come first to cover our concrete environment with trees to gift our future generations a healthy society.`,
    text1:`Our modern technology owes ecology an apology. Therefore, GREENATHON is a race where NHRF and its members....`,
    image: gogreen,
    image1: greenathan1,
    leftLogo: leftLogo2,
    rightLogo: rightLogo3,
    blogs: [
  { id: 1, image: greenathan1 },
  { id: 2, image: greenathan2 },
  { id: 3, image: greenathan3 },
  { id: 4, image: greenathan4 },
  { id: 5, image: greenathan5 },
  { id: 6, image: greenathan6 },
  { id: 7, image: greenathan7 },
  { id: 8, image: greenathan8 },
  { id: 9, image: greenathan9 },
  { id: 10, image: greenathan10 },
  { id: 11, image: greenathan11 },
  { id: 12, image: greenathan12 },
    ],
    projects:[]
  },

  {
    id: 3,
    title: "Prapti",
    text: `Mahatma Gandhi said, "The best way to find yourself is to lose yourself in the service of others." Project Prapti has been launched to bring smiles to the faces of those who are often neglected by our modern, civilized, and flourished society. Their attainment is our achievement of success.`,
    text1:`Mahatma Gandhi said, "The best way to find yourself is to lose yourself in the service of others." Project Prapti....`,
    image: nirmaan,
    image1: prapti2,
    leftLogo: leftLogo3,
    rightLogo: rightLogo1,
    blogs: [
      { id: 1, image: prapti1 },
      { id: 2, image: prapti2 },
      { id: 3, image: prapti3 },
      { id: 4, image: prapti4 },
      { id: 5, image: prapti5 },
      { id: 6, image: prapti6 },
      { id: 7, image: prapti7 },
      { id: 8, image: prapti8 },
      { id: 9, image: prapti9 },
      { id: 10, image: prapti10 },
      { id: 11, image: prapti11 },
      { id: 12, image: prapti12 },
      { id: 13, image: prapti13 },
      { id: 14, image: prapti14 },
      { id: 15, image: prapti15 },
      { id: 16, image: prapti16 },
      { id: 17, image: prapti17 },
      { id: 18, image: prapti18 },
      { id: 19, image: prapti19 },
      { id: 20, image: prapti20 },
      { id: 21, image: prapti21 },
      { id: 22, image: prapti22 },
      { id: 23, image: prapti23 },
      { id: 24, image: prapti24 },
      { id: 25, image: prapti25 },
      { id: 26, image: prapti26 },
      { id: 27, image: prapti27 },
      { id: 28, image: prapti28 },
      { id: 29, image: prapti29 },
      { id: 30, image: prapti30 },
      { id: 31, image: prapti31 },
      { id: 32, image: prapti32 },
      { id: 33, image: prapti33 },
      { id: 34, image: prapti34 },
      { id: 35, image: prapti35 },
      { id: 36, image: prapti36 },
      { id: 37, image: prapti37 },
      { id: 38, image: prapti38 },
    ],
    projects:[
      {
        id: 1,
        title: "Janata Henshel - Community Kitchen",
        image: janata7,
        image1: janata5,
        galleries: [
          { id: 1, image: janata1},
          { id: 2, image: janata2 },
          { id: 3, image: janata3 },
          { id: 4, image: janata4 },
          { id: 5, image: janata5 },
          { id: 6, image: janata6 },
          { id: 7, image: janata7 },
          { id: 8, image: janata8 }
        ]
      },
      {
        id: 2,
        title: "Natural Calamity Relief Works",
        image: natural1,
        image1: natural14,
        galleries: [
          { id: 1, image: natural1 },
          { id: 2, image: natural2 },
          { id: 3, image: natural3 },
          { id: 4, image: natural4 },
          { id: 5, image: natural5 },
          { id: 6, image: natural6 },
          { id: 7, image: natural7 },
          { id: 8, image: natural8 },
          { id: 9, image: natural9 },
          { id: 10, image: natural10 },
          { id: 11, image: natural11 },
          { id: 12, image: natural12 },
          { id: 13, image: natural13 },
          { id: 14, image: natural14 },
          { id: 15, image: natural15 },
          { id: 16, image: natural16 },
          { id: 17, image: natural17 },
          { id: 18, image: natural18 },
          { id: 19, image: natural19 }
        ]
      }
    ]
  },
  {
    id: 4,
    title: "Diya",
    text: `An investment in knowledge pays the best interest. Diya will bring light by holding the hand of NHRF to build an educated society by teaching the underprivileged students, and will enlighten the minds of the pupils with humanity and generosity. Diya will promote employment too to those who will achieve the qualities what NHRF has dreamt of to cultivate and nourish.`,
    text1:`An investment in knowledge pays the best interest. Diya will bring light by holding the hand of NHRF .....`,
    image: gyaan,
    image1: gyaan,
    leftLogo: leftLogo4,
    rightLogo: rightLogo2,
    blogs: [
      // {
      //   id: 1,
      //   title: "Evening Classes for Kids",
      //   name: "Igniting Young Minds",
      //   description:
      //     "Evening education sessions for underprivileged children, focusing on basic literacy and life skills.",
      //   image: gyaan,
      // },
      // {
      //   id: 2,
      //   title: "Employment Training Program",
      //   name: "Building Careers",
      //   description:
      //     "Training programs aimed at equipping individuals with professional skills to improve employability.",
      //   image: gyaan,
      // },
    ],
    projects:[]
  },

];

function SliderComp() {
  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();
  const nextCard = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % cards.length);
  };

  const prevCard = () => {
    setActiveIndex((prevIndex) => (prevIndex - 1 + cards.length) % cards.length);
  };

  const handleLearnMore = (id) => {
    navigate(`/projects/${id}`);
  };
 // Auto-slide functionality
  // useEffect(() => {
  //   const autoSlide = setInterval(() => {
  //     nextCard();
  //   }, 5000); // Change slides every 5 seconds

  //   return () => clearInterval(autoSlide); // Cleanup on component unmount
  // }, []);

  return (
    <div className="slider-comp-container">

<div className="carousel-header">
      <h1><span style={{color:'yellow'}}>OUR </span> INITIATIVES</h1>
    </div>

       
      {/* Left background */}
      <div className="background left" />

      {/* Carousel */}
      <div className="carousel">
        {cards.map((card, index) => {
          const isActive = index === activeIndex;
          const isPrev = index === (activeIndex - 1 + cards.length) % cards.length;
          const isNext = index === (activeIndex + 1) % cards.length;

          let className = "carousel-card";
          if (isActive) className += " active";
          if (isPrev) className += " prev";
          if (isNext) className += " next";

          return (
            <div key={card.id} className={className}>
              <Card className="custom-card">
                 {/* Left logo */}
                 <img src={card.leftLogo} alt="Left Logo" className="card-left-logo" />
                {/* Right logo */}
                <img src={card.rightLogo} alt="Right Logo" className="card-right-logo" />

                <Card.Img
                  variant="top"
                  src={card.image}
                  alt={card.title}

                  className="custom-card-img"
                />
              
                <Card.Body>
                  <Card.Title>{card.title}</Card.Title>
                  <Card.Text>{card.text1}</Card.Text>
                  <Button variant="primary" onClick={() => handleLearnMore(card.id)}>
                    Learn More
                  </Button>
                </Card.Body>
              </Card>
            </div>
          );
        })}
      </div>

      {/* Right background */}
      <div className="background right" />

      {/* Navigation Buttons */}
      <button className="arrow left-arrow" onClick={prevCard}>
        &#x276E;
      </button>
      <button className="arrow right-arrow" onClick={nextCard}>
        &#x276F;
      </button>
    </div>
  );
}

export default SliderComp;
